import { useMemo } from 'react';
import { useGetDriverConversationsQuery } from '@store/rtk/driverChat';
import { DriverConversation } from '@component/DriverChat/types';

/**
 * ACTIVE plus TODAY, de-duplicated: the active list is always loaded (it
 * drives launcher visibility), the TODAY list only when `includeToday` is set
 * (panel open), so closed conversations stay readable without extra traffic.
 */
export const useDriverConversations = (skip: boolean, includeToday = false) => {
  const active = useGetDriverConversationsQuery({ filter: 'ACTIVE' }, { skip });
  const today = useGetDriverConversationsQuery(
    { filter: 'TODAY' },
    { skip: skip || !includeToday }
  );

  const conversations = useMemo(() => {
    const byId = new Map<number, DriverConversation>();
    [...(today.data ?? []), ...(active.data ?? [])].forEach((c) =>
      byId.set(c.conversationId, c)
    );
    return [...byId.values()];
  }, [active.data, today.data]);

  return {
    conversations,
    activeConversations: active.data ?? [],
    isLoading: active.isLoading || today.isLoading,
    isError: active.isError || today.isError,
    refetch: () => {
      active.refetch();
      if (includeToday) today.refetch();
    },
  };
};
